import { render, staticRenderFns } from "./membershipplan.vue?vue&type=template&id=2bb6c973&scoped=true"
import script from "./membershipplan.vue?vue&type=script&lang=js"
export * from "./membershipplan.vue?vue&type=script&lang=js"
import style0 from "./membershipplan.vue?vue&type=style&index=0&id=2bb6c973&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6c973",
  null
  
)

export default component.exports